Academy.AskAcademy = {
	/**
	 * Display Ask Aops Academy form
	 */
	display: function (checked) {
		// contruct HTML - inline to prevent requirement of having to have
		// Handlebars loaded
		// We split the html code into 3 parts to handle a change between PC and VC
		const isNational = Academy.campus.id === "national";
		const isLumen = Academy.campus.id === "lumen";

		var html = [
			'<div class="aops-modal-body clearfix askaops">',
			'<div class="askaops-categories">',
			"<h1>Ask AoPS Academy</h1>",
			"<strong>I have a question about:</strong><br>",
			'<div style="padding-left:10px;padding-top:10px;line-height:2em;">',
			'<label><input type="radio" name="askaops-category" value="general" checked="checked"> General Information</label>',
			'<label><input type="radio" name="askaops-category" value="current"> Current Student</label>',
			isLumen
				? ""
				: '<label><input type="radio" name="askaops-category" value="billing"> Billing Information</label>',
			'<label><input type="radio" name="askaops-category" value="technical"> Technical Support</label>',
			'<label><input type="radio" name="askaops-category" value="other"> Other</label>',
			"</div></div>",
			'<div class="askaops-form">',
			'<div id="askaops-blurb">Have a general question about ',
			Academy.campus.name,
			"? Let us know below.</div>",
			'<div id="askaops-error" class="error-box"></div>',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-subject" class="form-control" placeholder="Message Subject">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-ordernumber" class="askaops-ordernumber form-control" placeholder="Order number - if known">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-course" class="askaops-course form-control" placeholder="Class name and id - if known">',
			'<textarea data-hj-suppress="" data-hj-masked="" id="askaops-message" class="form-control"  style="margin-top:10px;height:100px;" placeholder="How can we help you?"></textarea>',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-name" style="margin-top:10px" class="form-control" placeholder="Your name">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-email" style="margin-top:10px" class="form-control" placeholder="Your email address">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-student-name" style="margin-top:10px" class="form-control" placeholder="Student name">',
			'<input data-hj-suppress="" data-hj-masked="" id="askaops-username" class="askaops-username form-control" placeholder="AoPS Username (optional)">',
			'<table style="margin-top:10px"><tr>',
			isLumen
				? ""
				: '<td width="25" valign="top"><input id="ask-maillist" type="checkbox" name="maillist"></td>',
			'<td><label for="ask-maillist">',
			isLumen
				? ""
				: [
						"(Optional) Please add my email to AoPS Academy's mailing lists to be notified about ",
						isNational
							? "new AoPS Academy locations and other"
							: "upcoming classes, new Academy offerings, and",
						" Academy events. I consent to joining the mailing lists and am over 16 years old.",
				  ].join(""),
			"</label></td></tr></table>",
			'<div class="text-right">',
			'<input id="askaops-submit" style="margin-top:10px" type="submit" class="btn-lg btn btn-primary" value="Submit your message">',
			"</div>",
			'<p class="text-right">Your information will be used in accordance with our <a class="a" href="/legal/privacy" target="_blank">Privacy&nbsp;Policy</a>.</p>',
			"</div></div>",
		].join("");

		// Display the ask aops form
		AoPS.Ui.Modal.showPlain({
			body: html,
			width: "75%",
			onClose: this.onClose,
			scrollable: false,
			frame_class: "askaops-modal",
			// v Unsets the undesireable, fixed height so modal gets the correct height automatically
			height: "",
			max_height: "",
		});
		$(".askaops-modal")
			.parent(".aops-modal-wrapper")
			.addClass("askaops-modal-wrapper");

		if (typeof checked !== "undefined") {
			setTimeout(function () {
				if (checked === "current") {
					$(".askaops input[name='askaops-category'][value=current]").prop(
						"checked",
						true
					);
					Academy.AskAcademy.onChange();
				} else if (checked === "technical") {
					$(".askaops input[name='askaops-category'][value=technical]").prop(
						"checked",
						true
					);
					Academy.AskAcademy.onChange();
				} else if (checked === "billing") {
					$(".askaops input[name='askaops-category'][value=billing]").prop(
						"checked",
						true
					);
					Academy.AskAcademy.onChange();
				}
			}, 1);
		}
		// Could not get onShow to work in modal so just putting it here.
		this.onShow();
	},

	/**
	 * Event called when the "I have a question about:" radio buttons
	 * are changed. Basically sets the blurb above the form.
	 */
	onChange: function (e) {
		var selected = $(".askaops input[name='askaops-category']:checked").val();

		var general_rec_blurb = [
			"Have a general question about " + Academy.campus.name + "?",
			"Let us know below.",
		].join(" ");

		var current_student_blurb = [
			"Have a question about a current enrollment? Need to send us a message about your child? ",
			"Please include either your student's name or AoPS username below along with your message. ",
		].join(" ");

		var billing_blurb = [
			"Have a question about billing? Let us know below.",
		].join(" ");

		var tech_blurb = [
			"Please include a detailed description of the error or issue you ",
			"are experiencing.",
		];

		var other_blurb = "";

		$("#askaops-username").hide();
		$("#askaops-ordernumber").hide();
		$("#askaops-course").hide();
		$("#askaops-student-name").hide();
		switch (selected) {
			case "general":
				$("#askaops-blurb").html(general_rec_blurb);
				break;
			case "current":
				$("#askaops-student-name").show();
				$("#askaops-blurb").html(current_student_blurb);
				break;
			case "billing":
				$("#askaops-blurb").html(billing_blurb);
				break;
			case "technical":
				$("#askaops-student-name").show();
				$("#askaops-username").show();
				$("#askaops-blurb").html(tech_blurb);
				break;
			case "other":
				$("#askaops-blurb").html(other_blurb);
				break;
		}
	},

	/**
	 * Submit form to server when submit button is pressed
	 */
	onSubmit: function () {
		$("#askaops-submit").off("click", Academy.AskAcademy.onSubmit);
		var cdid_email = "";
		if (window.localStorage) {
			cdid_email = window.localStorage.getItem("cdid");
		}

		var type = $(".askaops input[name='askaops-category']:checked").val();
		var maillist = $("#ask-maillist")[0].checked;
		$.post(
			"/m/contact/ajax.php",
			{
				action: "email",
				type: type,
				username: $("#askaops-username").val(),
				email: $("#askaops-email").val(),
				name: $("#askaops-name").val(),
				student_name: $("#askaops-student-name").val(),
				subject: $("#askaops-subject").val(),
				message: $("#askaops-message").val(),
				course: $("#askaops-course").val(),
				maillist: maillist,
				url: window.location.href,
				cdid: cdid_email,
			},
			function (data) {
				if (data.error_msg) {
					$("#askaops-error").html(data.error_msg).show();
					$("#askaops-submit").on("click", Academy.AskAcademy.onSubmit);
				} else {
					AoPS.Ui.Modal.closeTopModal();

					Academy.AskAcademy.submitEventToAnalytics(type, maillist);

					if (!data.response.thanks) {
						var thankYouMessage = [
							"<p>Thank you. We have recieved your comment or question.</p>",
							"<p>One of our staff members will respond to you within two business days.</p>",
						];
						AoPS.Ui.Modal.showAlertQuick(thankYouMessage);
					} else {
						AoPS.Ui.Modal.showAlertQuick(data.response.thanks);
					}
				}
			}
		);
	},

	/**
	 * Enable events when modal is displayed
	 */
	onShow: function () {
		$(".askaops input[name='askaops-category']").on("change", this.onChange);
		this.onChange();
		$("#askaops-submit").on("click", this.onSubmit);
		$("#askaops-subject").focus();
	},

	/**
	 * Disable events when modal goes byebye
	 */
	onClose: function () {
		$(".askaops input[name='askaops-category']").off("change", this.onChange);
		$("#askaops-submit").off("click", this.onSubmit);
	},
	submitEventToAnalytics: function (type, maillist) {
		var role = "not_registered";
		if (AoPS.session.logged_in) {
			var roles = AoPS.session.role.split(",");
			if (roles.indexOf("officestaff") >= 0 || roles.indexOf("admin") >= 0) {
				role = "staff";
			} else if (roles.indexOf("parent") >= 0) {
				role = "parent";
			} else {
				role = "registered_user";
			}
		}
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: "ask-academy",
			campus: Academy.campus.id,
			contact_type: type,
			joined_maillist: maillist,
			logged_in: AoPS.session.logged_in,
			role: role,
		});
	},
};
